import { Body, Controller, Delete, Get, Param, Patch, Post, Query, UseGuards } from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiOperation, ApiTags } from '@nestjs/swagger';
import { RequireModule } from '../../auth/decorators/require-module.decorator';
import { RequirePermission } from '../../auth/decorators/require-permission.decorator';
import type { LoginUserInfo } from '../../auth/dto/login.dto';
import { GetUser } from '../../auth/get-user.decorator';
import { ModuleGuard } from '../../auth/guards/module.guard';
import { PermissionGuard } from '../../auth/guards/permission.guard';
import { CreateConceptoDto, QueryConceptosDto, UpdateConceptoDto } from '../dto/conceptos.dto';
import { ConceptosService } from '../services/conceptos.service';

@ApiTags('RRHH - Conceptos de liquidación')
@Controller({ path: 'rrhh/conceptos', version: '1' })
@UseGuards(AuthGuard('jwt'), ModuleGuard, PermissionGuard)
@RequireModule('RRHH')
@ApiBearerAuth()
export class ConceptosController {
  constructor(private readonly service: ConceptosService) {}

  @Get()
  @RequirePermission('RRHH', 'RH_CON_CONCEPTO_VER')
  @ApiOperation({ summary: 'Listar conceptos de liquidación' })
  listar(@GetUser() user: LoginUserInfo, @Query() query: QueryConceptosDto) {
    return this.service.listar(user.empresa_id, query);
  }

  @Post()
  @RequirePermission('RRHH', 'RH_CON_CONCEPTO_CREAR')
  @ApiOperation({ summary: 'Crear concepto de liquidación' })
  crear(@GetUser() user: LoginUserInfo, @Body() dto: CreateConceptoDto) {
    return this.service.crear(user.empresa_id, dto);
  }

  @Patch(':id')
  @RequirePermission('RRHH', 'RH_CON_CONCEPTO_EDITAR')
  @ApiOperation({ summary: 'Editar concepto' })
  actualizar(
    @Param('id') id: string,
    @GetUser() user: LoginUserInfo,
    @Body() dto: UpdateConceptoDto,
  ) {
    return this.service.actualizar(id, user.empresa_id, dto);
  }

  @Delete(':id')
  @RequirePermission('RRHH', 'RH_CON_CONCEPTO_ELIMINAR')
  @ApiOperation({ summary: 'Eliminar concepto (no permitido para conceptos del sistema)' })
  eliminar(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.eliminar(id, user.empresa_id);
  }
}
